<div [formGroup]="form"
     class="flex-col gap-16">
    <div class="flex-col gap-8">
        <label>{{ 'COMMON.NAME'|translate }} <span class="required">*</span></label>
        <input class="ui-input ui-input-40"
               formControlName="name">
    </div>

    <div class="flex-col gap-8">
        <label>
            {{ 'FLOW_CHART.NODES.SCHEDULE_TRIGGER.INTERVALS_LABEL'|translate }}
            <span class="required">*</span>
        </label>

        <mat-select class="ui-selector ui-selector-40"
                    formControlName="interval">
            @for(intervalKey of intervalKeys; track intervalKey) {
            <mat-option [value]="intervalKey">{{intervalsMap[intervalKey]|translate}}</mat-option>
            }
        </mat-select>
    </div>

    @let interval = form.controls['interval'].value;

    @switch(interval) {
    @case(intervalsEnum.Seconds) {
    <div class="flex-col gap-8">
        <label>{{ 'FLOW_CHART.NODES.SCHEDULE_TRIGGER.SECONDS_LABEL'|translate }} <span class="required">*</span></label>
        <input formControlName="seconds"
               class="ui-input ui-input-40"
               type="number"
               min="1"
               max="59" />
    </div>
    }
    @case(intervalsEnum.Minutes) {
    <div class="flex-col gap-8">
        <label>{{ 'FLOW_CHART.NODES.SCHEDULE_TRIGGER.MINUTES_LABEL'|translate }} <span class="required">*</span></label>
        <input formControlName="minutes"
               class="ui-input ui-input-40"
               type="number"
               min="1"
               max="59" />
    </div>
    }
    @case(intervalsEnum.Hours) {
    <div class="flex-col gap-8">
        <label>{{ 'FLOW_CHART.NODES.SCHEDULE_TRIGGER.HOURS_LABEL'|translate }} <span class="required">*</span></label>
        <input formControlName="hours"
               class="ui-input ui-input-40"
               type="number"
               min="1"
               max="23" />
    </div>
    }
    @case(intervalsEnum.Days) {
    <div class="flex-col gap-8">
        <label>{{ 'FLOW_CHART.NODES.SCHEDULE_TRIGGER.DAYS_LABEL'|translate }} <span class="required">*</span></label>
        <input formControlName="days"
               class="ui-input ui-input-40"
               type="number"
               min="1"
               max="31" />
    </div>
    }
    @case(intervalsEnum.Weeks) {
    <div class="flex-col gap-8">
        <label>{{ 'FLOW_CHART.NODES.SCHEDULE_TRIGGER.WEEKS_LABEL'|translate }} <span class="required">*</span></label>
        <input formControlName="weeks"
               class="ui-input ui-input-40"
               type="number"
               min="1" />
    </div>
    }
    @case(intervalsEnum.Custom) {
    <div class="flex-col gap-8">
        <label>{{ 'FLOW_CHART.NODES.SCHEDULE_TRIGGER.CUSTOM_LABEL'|translate }}</label>
        <input formControlName="custom"
               class="ui-input ui-input-40" />
    </div>
    }
    }

    @if(interval === intervalsEnum.Weeks) {
    <div class="flex-col gap-8">
        <label>{{ 'FLOW_CHART.NODES.SCHEDULE_TRIGGER.TRIGGER_ON_DAY'|translate }}</label>

        <mat-select class="ui-selector ui-selector-40"
                    formControlName="atDay">
            @for(dayKey of dayKeys; track dayKey) {
            <mat-option [value]="dayKey">{{daysMap[dayKey]|translate}}</mat-option>
            }
        </mat-select>
    </div>
    }


    @if(interval === intervalsEnum.Days ||
    interval === intervalsEnum.Weeks) {
    <div class="flex-col gap-8">
        <label>{{ 'FLOW_CHART.NODES.SCHEDULE_TRIGGER.TRIGGER_AT_HOUR'|translate }}</label>

        <mat-select class="ui-selector ui-selector-40"
                    formControlName="atHour">
            @for(hourKey of hourKeys; track hourKey) {
            <mat-option [value]="hourKey">{{hoursMap[hourKey]|translate}}</mat-option>
            }
        </mat-select>
    </div>
    }

    @if(interval === intervalsEnum.Hours ||
    interval === intervalsEnum.Days ||
    interval === intervalsEnum.Weeks) {
    <div class="flex-col gap-8">
        <label>{{ 'FLOW_CHART.NODES.SCHEDULE_TRIGGER.TRIGGER_AT_MIN'|translate }}</label>
        <input formControlName="atMinute"
               class="ui-input ui-input-40"
               type="number"
               min="1"
               max="59" />
    </div>
    }
</div>